/* src/app/sections/crs-section/crs-section.component.css */
/*# sourceMappingURL=crs-section.component.css.map */
